import React from 'react';

const IconMoreHorz = () => {
  return (
    <svg data-test="iconmorehorz" width="16" height="4" viewBox="0 0 16 4" fill="none" className="MuiSvgIcon-root">
      <circle cx="2" cy="2" r="2" transform="rotate(-90 2 2)" fill="#30435D"/>
      <circle cx="8" cy="2" r="2" transform="rotate(-90 8 2)" fill="#30435D"/>
      <circle cx="14" cy="2" r="2" transform="rotate(-90 14 2)" fill="#30435D"/>
    </svg>
  );
};

export default IconMoreHorz;

